// extracted by mini-css-extract-plugin
module.exports = {"search-input":"styles_search-input__DfEni","search-input__input":"styles_search-input__input__3kB70","search-input__input-wrapper":"styles_search-input__input-wrapper__nKXWD"};